import { ref } from 'vue'

export type PortalOrgId = 'facility' | 'visit'

const STORAGE_KEY = 'portal.orgType'

export function isPortalOrgId(value: string | null | undefined): value is PortalOrgId {
  return value === 'facility' || value === 'visit'
}

function readStoredOrgType(): PortalOrgId | null {
  try {
    const fromLocal = localStorage.getItem(STORAGE_KEY)
    if (isPortalOrgId(fromLocal)) return fromLocal

    const fromSession = sessionStorage.getItem(STORAGE_KEY)
    if (isPortalOrgId(fromSession)) {
      localStorage.setItem(STORAGE_KEY, fromSession)
      sessionStorage.removeItem(STORAGE_KEY)
      return fromSession
    }
  } catch {
    /* private mode 등 */
  }
  return null
}

function writeStoredOrgType(id: PortalOrgId | null) {
  try {
    if (id) localStorage.setItem(STORAGE_KEY, id)
    else localStorage.removeItem(STORAGE_KEY)
  } catch {
    /* private mode 등 */
  }
}

const storedOrg = readStoredOrgType()

export const portalOrgType = ref<PortalOrgId | null>(storedOrg)
/** 예전 사업구분 선택 화면용. 선택 페이지는 없앴으므로 열리지 않는다. */
export const landingGateOpen = ref(false)
/** 전환 중에는 푸터·페이지 스크롤이 끼어들지 않게 한다. */
export const landingTransit = ref(false)

export function setPortalOrgType(id: PortalOrgId) {
  portalOrgType.value = id
  writeStoredOrgType(id)
}

/** 사업구분을 다시 고를 때 메모리와 저장값을 함께 지운다. */
export function clearPortalOrgType() {
  portalOrgType.value = null
  writeStoredOrgType(null)
}

export function closeLandingGate() {
  landingGateOpen.value = false
}

export function openLandingGate() {
  landingGateOpen.value = true
}
